import React from 'react';
import PropTypes from 'prop-types';

export default class FieldProfilePictureInput extends React.PureComponent {
  static propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.node,
    emptyValuePreview: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {preview: null};
  }

  onPreviewReady = evt => {
    this.setState({preview: evt.target.error ? null :evt.target.result});
  };

  generatePreview(file) {
    this.destroyPreview();

    if (file) {
      this._fileReader.readAsDataURL(file);
    }
  }

  destroyPreview() {
    const {preview} = this.state;

    if (preview) {
      window.URL.revokeObjectURL(preview);
      this.setState({preview: null});
    }
  }

  componentDidMount() {
    this._fileReader = new FileReader();
    this._fileReader.onloadend = this.onPreviewReady;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      this.generatePreview(nextProps.input.value[0]);
    }
  }

  componentWillUnmount() {
    this.destroyPreview();
  }

  render() {
    const {input, label, emptyValuePreview} = this.props;
    const {preview} = this.state;

    return (
      <label className="profile__img">
        <input
          className="profile__img-input"
          type="file"
          name={input.name}
          multiple={false}
          accept="image/jpeg, image/png"
          onChange={input.onChange}
        />

        <img src={preview || emptyValuePreview} alt="Your profile image"/>
        <span className="profile__img-upload">{label}</span>
        {/*<span className="profile__img-delete"/>*/}
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./components/fields/fieldProfilePictureInput/FieldProfilePictureInput.js